// import React, { useEffect, useState } from "react";
// import axios from "../../AxiosConfig";
// import { useNavigate } from "react-router-dom";
// import CompanySales from "./CompanySales";
// import axiosConfig from "../../AxiosConfig"
// const Target = () => {
//   const monthOrder = [
//     "April", "May", "June", "July", "August", "September",
//     "October", "November", "December",
//     "January", "February", "March"
//   ];
//   const boxStyle = {
//     padding: "8px",
//     marginBottom: "8px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     background: "#f5f5f5",

//   };
//   const getCurrentFY = () => {
//     const today = new Date();
//     const month = today.getMonth(); // 0 = Jan
//     const year = today.getFullYear();

//     if (month >= 3) {
//       // April or later
//       return `${year}-${(year + 1).toString().slice(-2)}`;
//     } else {
//       // Jan–March
//       return `${year - 1}-${year.toString().slice(-2)}`;
//     }
//   };
//   const getCurrentMonthIndex = () => {
//     const today = new Date();
//     const currentMonth = today.getMonth(); // 0 = Jan

//     const fyStartMonth = 3; // April

//     if (currentMonth >= fyStartMonth) {
//       return currentMonth - fyStartMonth;
//     } else {
//       return currentMonth + 9;
//     }
//   };
//   const history = useNavigate();
//   const [fy, setFy] = useState(getCurrentFY());
//   const [roles, setRoles] = useState([]);
//   const [activeRole, setActiveRole] = useState(null);
//   const [monthsData, setMonthsData] = useState([]);
//   const [usersList, setUsersList] = useState([]);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [selectedManager, setSelectedManager] = useState(null);
//   const [selectedSalesPerson, setSelectedSalesPerson] = useState(null);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);

//   const [managerList, setManagerList] = useState([]);
//   const [salesPersonList, setSalesPersonList] = useState([]);
//   const [customerList, setCustomerList] = useState([]);
//   const [allMonthsData, setAllMonthsData] = useState([]);
//   const [yearlyTarget, setYearlyTarget] = useState(0);
//   // 🔥 ADD THIS
//   const [hierarchyLevel, setHierarchyLevel] = useState("manager");
//   const [currentManagers, setCurrentManagers] = useState([]);
//   const [currentSalesPersons, setCurrentSalesPersons] = useState([]);
//   const [currentCustomers, setCurrentCustomers] = useState([]);
//   const [allUsers, setAllUsers] = useState([]);
//   const [viewType, setViewType] = useState("company");
//   useEffect(() => {
//     getAllUsers();
//   }, []);
//   useEffect(() => {
//     if (viewType === "company") {
//       loadTargetData();
//     }
//   }, [viewType, fy]);
//   const getAllUsers = async () => {
//     try {
//       const user = JSON.parse(localStorage.getItem("userData") || "{}");

//       const res = await axiosConfig.get(`/user/user-list/${user?.database}`);

//       const allUsersData = res.data?.User || [];

//       const onlyCustomers = allUsersData.filter((user) => {
//         const roleName = user?.rolename?.roleName?.toLowerCase();
//         const partyType = user?.partyType?.toLowerCase();
//         const companyName = user?.CompanyName?.toUpperCase();
//         const status = user?.status?.toLowerCase(); // 👈 add this

//         return (
//           roleName === "customer" &&          // ✅ only customer
//           partyType === "debitor" &&          // ✅ only debitor
//           companyName !== "CASH" &&
//           status === "active"
//         );
//       });
//       setAllUsers(onlyCustomers);
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   // 🔹 Load Roles
//   useEffect(() => {
//     loadRoles();
//   }, []);

//   useEffect(() => {
//     if (!activeRole) return; // 🔥 IMPORTANT
//     loadTargetData();
//   }, [fy, activeRole]);
//   useEffect(() => {
//     if (!activeRole) return;

//     let usersMap = {};

//     monthsData.forEach((month) => {
//       const layer = month.layers.find(
//         (l) => l.rolePosition === activeRole.rolePosition
//       );

//       layer?.users?.forEach((u) => {
//         if (!usersMap[u.userId]) {
//           usersMap[u.userId] = u;
//         }
//       });
//     });

//     setUsersList(Object.values(usersMap));
//   }, [activeRole, monthsData]);
//   // ---------------- LOAD ROLES ----------------
//   const loadRoles = async () => {
//     try {
//       const user = JSON.parse(localStorage.getItem("userData") || "{}");
//       const db = user?.database;

//       const res = await axiosConfig.get(
//         `/assign-role/view-assign-role/${db}`
//       );

//       const departments = res?.data?.Department || [];
//       const salesDept = departments.find(
//         (d) =>
//           d?.departmentName?.departmentName?.toLowerCase() === "sales"
//       );

//       if (!salesDept) return;

//       const roleList = salesDept.roles || [];
//       setRoles(roleList);

//       if (roleList.length > 0) {
//         setActiveRole(roleList[0]);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   useEffect(() => {
//     let total = 0;

//     allMonthsData.forEach((month) => {
//       const managerLayer = month.layers.find(
//         (l) => l.rolePosition === 1
//       );

//       if (!managerLayer) return;

//       // 🔵 Case 1: koi manager select nahi → sabka sum
//       if (!selectedManager) {
//         managerLayer.users.forEach((u) => {
//           total += Number(u.total || 0);
//         });
//       }

//       // 🟢 Case 2: specific manager selected
//       else {
//         const managerData = managerLayer.users.find(
//           (u) => u.userId === selectedManager.userId
//         );

//         if (managerData) {
//           total += Number(managerData.total || 0);
//         }
//       }
//     });

//     setYearlyTarget(total);
//   }, [selectedManager, allMonthsData]);
//   // ---------------- LOAD TARGET DATA ----------------
//   const loadTargetData = async () => {
//     try {
//       setAllMonthsData([]);
//       setMonthsData([]);
//       setManagerList([]);
//       setSalesPersonList([]);
//       setCustomerList([]);
//       setSelectedManager(null);
//       setSelectedSalesPerson(null);
//       setSelectedCustomer(null);
//       setYearlyTarget(0); // 🔥 IMPORTANT
//       if (!activeRole) return;
//       setLoading(true);
//       setMonthsData([]);
//       setManagerList([]);
//       setSalesPersonList([]);
//       setCustomerList([]);
//       setUsersList([]);
//       setSelectedUser(null);
//       // setSelectedManager(null);
//       // setSelectedSalesPerson(null);
//       // setSelectedCustomer(null);
//       const user = JSON.parse(localStorage.getItem("userData") || "{}");
//       const db = user?.database;

//       const res = await axiosConfig.get(
//         `/production-steps/view-workerTarget/${db}/${fy}`
//       );
//       console.log(res);
// debugger
//       const allMonths = res?.data?.data || [];

//       if (!allMonths.length) {
//         setAllMonthsData([]);
//         setMonthsData([]);
//         setManagerList([]);
//         setSalesPersonList([]);
//         setCustomerList([]);
//         setYearlyTarget(0);
//         return; // 🔥 STOP here
//       }
//       // setMonthsData(allMonths);
//       setAllMonthsData(allMonths);
//       setMonthsData(allMonths);
//       // setYearlyTarget(res.data.yearlyTarget);
//       let managerMap = {};
//       let salesMap = {};
//       let customerMap = {};
//       allMonths.forEach((month) => {
//         month.layers.forEach((layer) => {

//           // RolePosition 1 = Sales Manager
//           if (layer.rolePosition === 1) {
//             layer.users.forEach((u) => {
//               if (!managerMap[u.userId]) {
//                 managerMap[u.userId] = u;
//               }
//             });
//           }

//           // RolePosition 2 = Sales Person
//           if (layer.rolePosition === 2) {
//             layer.users.forEach((u) => {
//               if (!salesMap[u.userId]) {
//                 salesMap[u.userId] = u;
//               }
//             });
//           }

//           // RolePosition 3 = Customer
//           if (layer.rolePosition === 3) {
//             layer.users.forEach((u) => {
//               if (!customerMap[u.userId]) {
//                 customerMap[u.userId] = u;
//               }
//             });
//           }

//         });
//       });

//       setManagerList(Object.values(managerMap));
//       setSalesPersonList(Object.values(salesMap));
//       setCustomerList(Object.values(customerMap));
//       let usersMap = {};

//       allMonths.forEach((month) => {
//         const layer = month?.layers?.find(
//           (l) => l.rolePosition === activeRole.rolePosition
//         );

//         if (layer?.users?.length) {
//           layer.users.forEach((u) => {
//             if (!usersMap[u.userId]) {
//               usersMap[u.userId] = u;
//             }
//           });
//         }
//       });

//       const finalUsers = Object.values(usersMap);

//       setUsersList(finalUsers);

//       setSelectedUser(null);

//       setLoading(false);
//     } catch (err) {
//       console.log(err);
//       setLoading(false);
//     }
//   };
//   useEffect(() => {

//     if (!selectedManager) {
//       setMonthsData(allMonthsData);
//       return;
//     }

//     // -------- Filter months by selected manager --------
//     const filteredMonths = allMonthsData.filter((month) =>
//       month.layers
//         .find((l) => l.rolePosition === 1)
//         ?.users.some((u) => u.userId === selectedManager.userId)
//     );
//     setMonthsData(filteredMonths);

//     // -------- Rebuild Sales & Customer ONLY from filtered --------
//     let salesMap = {};
//     let customerMap = {};

//     filteredMonths.forEach((month) => {
//       month.layers.forEach((layer) => {

//         if (layer.rolePosition === 2) {
//           layer.users.forEach((u) => {
//             salesMap[u.userId] = u;
//           });
//         }

//         if (layer.rolePosition === 3) {
//           layer.users.forEach((u) => {
//             customerMap[u.userId] = u;
//           });
//         }

//       });
//     });

//     setSalesPersonList(Object.values(salesMap));
//     setCustomerList(Object.values(customerMap));

//   }, [selectedManager, allMonthsData]);

//   // ---------------- GET USER DATA FOR MONTH ----------------
//   const getUserMonthData = (month) => {
//     const layer = month.layers.find(
//       (l) => l.rolePosition === activeRole.rolePosition
//     );

//     return layer?.users.find(
//       (u) => u.userId === selectedUser?.userId
//     );
//   };



//   const getCurrentMonthTarget = (userId, rolePosition) => {
//     const currentMonthIndex = getCurrentMonthIndex();
//     const currentMonthName = monthOrder[currentMonthIndex];

//     const monthList = allMonthsData.filter(
//       (m) =>
//         m.month?.toLowerCase().trim() ===
//         currentMonthName.toLowerCase()
//     );
//     let total = 0;

//     monthList.forEach((month) => {
//       const layer = month.layers.find(
//         (l) => l.rolePosition === rolePosition
//       );

//       if (!layer) return;

//       const user = layer.users.find(
//         (u) => u.userId === userId
//       );

//       if (user) {
//         total += Number(user.total || 0);
//       }
//     });

//     return total;
//   };

//   const generateFYOptions = () => {
//     const startYear = 2022; // 👈 Fixed Start
//     const currentFY = getCurrentFY(); // e.g. 2025-26
//     const [currentStartYear] = currentFY.split("-");

//     const endYear = parseInt(currentStartYear) + 1;
//     // 👆 1 year future tak show karega (2026-27)

//     const fyList = [];

//     for (let year = startYear; year <= endYear; year++) {
//       fyList.push(`${year}-${(year + 1).toString().slice(-2)}`);
//     }

//     return fyList;
//   };
//   const renderMonthGrid = (selectedUser, rolePosition) => {
//     const currentMonthIndex = getCurrentMonthIndex();
//     return (
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(6, 1fr)",
//           gap: "15px",
//           marginTop: "20px"
//         }}
//       >
//         {monthsData.map((month, index) => {
//           const monthIndex = monthOrder.indexOf(month.month);
//           const isCurrentMonth = monthIndex === currentMonthIndex;
//           const isCustomer = rolePosition === 3;
//           const isClickable = isCustomer && isCurrentMonth;
//           const layer = month.layers.find(
//             (l) => l.rolePosition === rolePosition
//           );

//           const userMonthData = layer?.users.find(
//             (u) => u.userId === (selectedUser.userId || selectedUser._id)
//           );

//           if (!userMonthData) return null;

//           return (
//             <div
//               key={index}
//               onClick={() => {
//                 if (isClickable) {
//                   history.push({
//                     pathname: "/customer-target-edit",
//                     state: {
//                       fy: fy,
//                       month: month.month,
//                       customerData: userMonthData,
//                       incrementper: month.incrementper
//                     }
//                   });
//                 }
//               }}
//               style={{
//                 padding: "12px",
//                 border: "1px solid #ddd",
//                 borderRadius: "8px",

//                 background: isCustomer && !isCurrentMonth ? "#f1f1f1" : "#f9f9f9",

//                 // 👇 fade effect
//                 opacity: isCustomer && !isCurrentMonth ? 0.6 : 1,

//                 // 👇 cursor control
//                 cursor: isClickable ? "pointer" : "not-allowed",

//                 transition: "all 0.2s ease",
//                 textAlign: "center"
//               }}
//             >
//               <strong>{month.month}</strong>

//               <div style={{ marginTop: "8px", color: "#1b0404" }}>
//                 ₹ {Number(userMonthData.total || 0).toFixed(2)}
//               </div>

//               <div style={{ fontSize: "12px", color: "#1b0404" }}>
//                 Inc%: {month.incrementper}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };
//   return (
//     <div style={{ padding: "20px" }}>
//       {/* 🔹 TOP FILTER ROW */}
//       {viewType === "hierarchy" && activeRole && (
//         <div
//           style={{
//             display: "flex",
//             gap: "25px",
//             marginBottom: "30px",
//             flexWrap: "wrap",
//             alignItems: "flex-end"
//           }}
//         >

//           {/* FY Year */}
//           <div style={{ display: "flex", flexDirection: "column", minWidth: "180px" }}>
//             <label
//               style={{
//                 fontSize: "14px",
//                 fontWeight: "600",
//                 marginBottom: "6px",
//                 color: "#333"
//               }}
//             >
//               FY Year
//             </label>

//             <select
//               value={fy}
//               onChange={(e) => setFy(e.target.value)}
//               style={{
//                 padding: "5px 8px",
//                 borderRadius: "8px",
//                 border: "1px solid #ccc",
//                 fontSize: "14px",
//                 outline: "none",
//                 cursor: "pointer",
//                 backgroundColor: "#fff",
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
//               }}
//             >
//               {generateFYOptions().map((year) => (
//                 <option key={year} value={year}>
//                   {year}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Yearly Target */}
//           <div style={{ display: "flex", flexDirection: "column", minWidth: "180px" }}>
//             <label
//               style={{
//                 fontSize: "14px",
//                 fontWeight: "600",
//                 marginBottom: "6px",
//                 color: "#333"
//               }}
//             >
//               Yearly Target
//             </label>

//             <div
//               style={{
//                 padding: "6px 8px",
//                 borderRadius: "8px",
//                 background: "#e6f0ff",
//                 fontWeight: "600",
//                 fontSize: "14px",
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
//               }}
//             >
//               ₹ {Number(yearlyTarget || 0).toFixed(2)}
//             </div>
//           </div>

//         </div>
//       )}
//       {/* 🔹 ROLE TABS */}
//       <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
//         {/* 🔵 Company Target Button */}
//         <div style={{ display: "flex", flexDirection: "column", minWidth: "200px" }}>
//           <button
//             onClick={() => {
//               setViewType("company");

//               // 🔥 Reset selection
//               setSelectedManager(null);
//               setSelectedSalesPerson(null);
//               setSelectedCustomer(null);
//             }}
//             style={{
//               padding: "8px 15px",
//               borderRadius: "8px",
//               border: "none",
//               fontSize: "14px",
//               cursor: "pointer",
//               backgroundColor: viewType === "company" ? "#1e6bff" : "#d9dde3",
//               color: viewType === "company" ? "#fff" : "#000",
//               boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
//             }}
//           >
//             Company Target
//           </button>

//         </div>
//         {roles.map((role) => (
//           <button
//             key={role._id}
//             onClick={() => {
//               setActiveRole(role);
//               setViewType("hierarchy");
//               // 🔵 Manager Tab
//               if (role.rolePosition === 1) {
//                 setHierarchyLevel("manager");
//                 // setSelectedManager(null);
//                 // setSelectedSalesPerson(null);
//                 // setSelectedCustomer(null);
//               }

//               // 🟢 Sales Person Tab
//               // else if (role.rolePosition === 2) {
//               //   setHierarchyLevel("manager");  // Start from manager level
//               //   setSelectedManager(null);
//               //   setSelectedSalesPerson(null);
//               //   setSelectedCustomer(null);
//               // }
//               else if (role.rolePosition === 2) {

//                 // Agar pehle se salesperson selected hai
//                 if (selectedSalesPerson) {

//                   let customerMap = {};

//                   monthsData.forEach((month) => {

//                     const salesLayer = month.layers.find(
//                       (l) => l.rolePosition === 2
//                     );

//                     const customerLayer = month.layers.find(
//                       (l) => l.rolePosition === 3
//                     );

//                     const isSalesPresent = salesLayer?.users?.some(
//                       (u) => u.userId === selectedSalesPerson.userId
//                     );

//                     if (isSalesPresent && customerLayer?.users) {
//                       customerLayer.users.forEach((cust) => {
//                         customerMap[cust.userId] = cust;
//                       });
//                     }

//                   });

//                   setCurrentCustomers(Object.values(customerMap));
//                 }

//                 setHierarchyLevel("salesperson");
//               }

//               // 🟣 Customer Tab
//               else if (role.rolePosition === 3) {
//                 setHierarchyLevel("customer");
//                 // setSelectedManager(null);
//                 // setSelectedSalesPerson(null);
//                 // setSelectedCustomer(null);
//               }
//             }}
//             style={{
//               padding: "8px 15px",
//               background:
//                 viewType === "hierarchy" && activeRole?._id === role._id
//                   ? "#1e6bff"
//                   : "#d9dde3",

//               color:
//                 viewType === "hierarchy" && activeRole?._id === role._id
//                   ? "#fff"
//                   : "#000",
//               border: "none",
//               borderRadius: "8px",
//               cursor: "pointer"
//             }}
//           >
//             {role.roleName}
//           </button>
//         ))}
//       </div>

//       {loading && <p>Loading...</p>}

//       {/* 🔥 MAIN VIEW SWITCH */}
//       {viewType === "company" ? (
//         <CompanySales goToHierarchy={() => setViewType("hierarchy")} />
//       ) : (
//         !loading && (
//           <div style={{ display: "flex", gap: "20px" }}>

//             {/* LEFT SIDE USER LIST */}
//             <div
//               style={{
//                 width: "25%",
//                 border: "1px solid #ddd",
//                 borderRadius: "8px",
//                 padding: "10px",
//                 height: "500px",
//                 overflowY: "auto"
//               }}
//             >
//               <h4>{activeRole?.roleName} List</h4>

//               {/* 🔵 MANAGER TAB */}
//               {activeRole?.rolePosition === 1 &&
//                 managerList.map((manager) => {

//                   let salesMap = {};

//                   monthsData.forEach((month) => {
//                     const managerLayer = month.layers.find(
//                       (l) => l.rolePosition === 1
//                     );

//                     const salesLayer = month.layers.find(
//                       (l) => l.rolePosition === 2
//                     );

//                     const isManagerPresent = managerLayer?.users?.some(
//                       (u) => u.userId === manager.userId
//                     );

//                     if (isManagerPresent && salesLayer?.users) {
//                       salesLayer.users.forEach((sp) => {
//                         salesMap[sp.userId] = sp;
//                       });
//                     }
//                   });

//                   const managerSalesPersons = Object.values(salesMap);

//                   return (
//                     <div key={manager.userId}>

//                       {/* 🔵 MANAGER */}
//                       <div
//                         onClick={() => {

//                           console.log("Manager Clicked", manager);
//                           setSelectedManager(manager);
//                           setSelectedSalesPerson(null);   // ✅ ADD
//                           setSelectedCustomer(null);
//                           setViewType("hierarchy"); // ✅ ADD THIS
//                         }}
//                         style={{
//                           ...boxStyle,
//                           background:
//                             selectedManager?.userId === manager.userId
//                               ? "#1e6bff"
//                               : "#f1f1f1",
//                           color:
//                             selectedManager?.userId === manager.userId
//                               ? "#fff"
//                               : "#000"
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             width: "100%"
//                           }}
//                         >
//                           <span>{manager.firstName}</span>

//                           <span>
//                             ₹ {getCurrentMonthTarget(manager.userId, 1).toFixed(2)}
//                           </span>
//                         </div>
//                       </div>

//                       {/* 🟢 SALESPERSON */}
//                       {selectedManager?.userId === manager.userId &&
//                         managerSalesPersons.map((sp) => (
//                           <div
//                             key={sp.userId}
//                             onClick={() => {
//                               setSelectedSalesPerson(sp);
//                               setSelectedCustomer(null);
//                               setViewType("hierarchy"); // ✅ ADD THIS
//                             }}
//                             style={{
//                               marginLeft: "20px",
//                               ...boxStyle,
//                               background:
//                                 selectedSalesPerson?.userId === sp.userId
//                                   ? "#28a745"
//                                   : "#f7f7f7"
//                             }}
//                           >
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 width: "100%"
//                               }}
//                             >
//                               <span>{sp.firstName}</span>

//                               <span>
//                                 ₹ {getCurrentMonthTarget(sp.userId, 2).toFixed(2)}
//                               </span>
//                             </div>
//                           </div>
//                         ))
//                       }

//                     </div>
//                   );
//                 })}

//               {/* 🟣 CUSTOMER TAB */}
//               {activeRole?.rolePosition === 3 &&
//                 allUsers.map((cust) => (
//                   <div
//                     key={cust.userId}
//                     onClick={() => {
//                       setSelectedCustomer(cust);
//                       setSelectedManager(null);
//                       setSelectedSalesPerson(null);
//                       setViewType("hierarchy");
//                     }}
//                     style={{
//                       ...boxStyle,
//                       display: "flex",                 // ✅ IMPORTANT
//                       justifyContent: "space-between", // ✅ push left-right
//                       alignItems: "center",
//                       background:
//                         selectedCustomer?.userId === cust.userId
//                           ? "#F1F1F1"
//                           : "#f1f1f1",
//                       color:
//                         selectedCustomer?.userId === cust.userId
//                           ? "#0a0404"
//                           : "#000"
//                     }}
//                   >
//                     <span>{cust.CompanyName}</span>

//                     <span>
//                       ₹ {getCurrentMonthTarget(cust._id || cust.userId, 3).toFixed(2)}
//                     </span>
//                   </div>
//                 ))
//               }

//               {/* 🔹 SALES PERSON TAB */}
//               {activeRole?.rolePosition === 2 &&
//                 salesPersonList.map((sp) => {

//                   const salesCustomers = allUsers.filter((user) => {
//                     return (
//                       user?.created_by === sp.userId ||
//                       user?.created_by?._id === sp.userId
//                     );
//                   });

//                   return (
//                     <div key={sp.userId}>

//                       {/* 🟢 SalesPerson */}
//                       <div
//                         onClick={() => setSelectedSalesPerson(sp)}
//                         style={{
//                           ...boxStyle,
//                           background:
//                             selectedSalesPerson?.userId === sp.userId
//                               ? "#28a745"
//                               : "#f1f1f1",
//                           color:
//                             selectedSalesPerson?.userId === sp.userId
//                               ? "#fff"
//                               : "#000"
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             width: "100%"
//                           }}
//                         >
//                           <span>{sp.firstName}</span>

//                           <span>
//                             ₹ {getCurrentMonthTarget(sp.userId, 2).toFixed(2)}
//                           </span>
//                         </div>
//                       </div>

//                       {/* 🟣 Customers */}
//                       {selectedSalesPerson?.userId === sp.userId &&
//                         salesCustomers.map((cust) => (
//                           <div
//                             key={cust.userId}
//                             onClick={() => setSelectedCustomer(cust)}
//                             style={{
//                               marginLeft: "20px",
//                               ...boxStyle
//                             }}
//                           >
//                             <div
//                               style={{
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 width: "100%"
//                               }}
//                             >
//                               <span>{cust.CompanyName}</span>

//                               <span>
//                                 ₹ {getCurrentMonthTarget(cust._id || cust.userId, 3).toFixed(2)}
//                               </span>
//                             </div>
//                           </div>
//                         ))}

//                     </div>
//                   );
//                 })}
//             </div>

//             {/* RIGHT SIDE MONTH DATA */}
//             <div
//               style={{
//                 flex: 1,
//                 border: "1px solid #ddd",
//                 borderRadius: "8px",
//                 padding: "15px"
//               }}
//             >
//               {!selectedManager && !selectedSalesPerson && !selectedCustomer && (
//                 <p>Select user to view data</p>
//               )}

//               {selectedManager && activeRole?.rolePosition === 1 && (
//                 <>
//                   <h3>Manager: {selectedManager.firstName}</h3>
//                   {renderMonthGrid(selectedManager, 1)}
//                 </>
//               )}

//               {selectedSalesPerson && (
//                 <>
//                   <h3 style={{ marginTop: "25px" }}>
//                     Sales Person: {selectedSalesPerson.firstName}
//                   </h3>
//                   {renderMonthGrid(selectedSalesPerson, 2)}
//                 </>
//               )}

//               {selectedCustomer && (
//                 <>
//                   <h3 style={{ marginTop: "25px" }}>
//                     Customer: {selectedCustomer.CompanyName}
//                   </h3>
//                   {renderMonthGrid(selectedCustomer, 3)}
//                 </>
//               )}
//             </div>
//           </div>
//         )
//       )}
//     </div>
//   );
// };

// export default Target;







// import React, { useEffect, useState } from "react";
// import axiosConfig from "../../AxiosConfig";
// import { useNavigate } from "react-router-dom";
// const Target = () => {
//   const navigate = useNavigate();
//   // =========================================================
//   // MONTH ORDER
//   // =========================================================
//   const monthOrder = [
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//     "January",
//     "February",
//     "March",
//   ];

//   // =========================================================
//   // FINANCIAL YEAR
//   // =========================================================
//   const getCurrentFY = () => {
//     const today = new Date();
//     const month = today.getMonth();
//     const year = today.getFullYear();

//     if (month >= 3) {
//       return `${year}-${year + 1}`;
//     }

//     return `${year - 1}-${year}`;
//   };

//   // =========================================================
//   // STATES
//   // =========================================================
//   const [fy, setFy] = useState(getCurrentFY());

//   const [targetData, setTargetData] = useState([]);

//   const [loading, setLoading] = useState(false);

//   const [viewType, setViewType] = useState("monthly");

//   // =========================================================
//   // LOAD TARGET DATA
//   // =========================================================
//   useEffect(() => {
//     loadTargetData();
//   }, [fy]);

//  const loadTargetData = async () => {
//   try {
//     setLoading(true);

//     const user = JSON.parse(
//       localStorage.getItem("userData") || "{}"
//     );

//     const db = user?.database;

//     console.log("========== WORKER TARGET REQUEST ==========");
//     console.log("Database:", db);
//     console.log("Financial Year:", fy);
//     console.log(
//       "URL:",
//       `/production-steps/view-workerTarget/${db}/${fy}`
//     );

//     if (!db) {
//       console.log("Database not found");
//       setTargetData([]);
//       return;
//     }

//     const res = await axiosConfig.get(
//       `/production-steps/view-workerTarget/${db}/${fy}`
//     );

//     console.log("WORKER TARGET RESPONSE =>", res?.data);

//    const data = Array.isArray(res?.data?.targets)
//   ? res.data.targets
//   : [];

//     console.log("WORKER TARGET DATA =>", data);

//     setTargetData(data);

//   } catch (error) {
//     console.log("========== WORKER TARGET ERROR ==========");
//     console.log("Status:", error?.response?.status);
//     console.log("Response:", error?.response?.data);
//     console.log("URL:", error?.config?.url);
//     console.log("Method:", error?.config?.method);

//     setTargetData([]);

//   } finally {
//     setLoading(false);
//   }
// };

//   // =========================================================
//   // FINANCIAL YEAR OPTIONS
//   // =========================================================
//   const generateFYOptions = () => {
//     const startYear = 2022;

//     const [currentStartYear] =
//       getCurrentFY().split("-");

//     const endYear =
//       parseInt(currentStartYear);

//     const fyList = [];

//     for (
//       let year = startYear;
//       year <= endYear;
//       year++
//     ) {
//       fyList.push(`${year}-${year + 1}`);
//     }

//     return fyList;
//   };

//   // =========================================================
//   // FORMAT NUMBER
//   // =========================================================
//   const formatNumber = (value) => {
//     return Number(value || 0).toLocaleString(
//       "en-IN",
//       {
//         maximumFractionDigits: 2,
//       }
//     );
//   };

//   // =========================================================
//   // GET MONTH NAME
//   //
//   // API me month field hai to use karega.
//   // Agar API me month nahi hai to createdAt se month
//   // nikalne ki zarurat nahi hai because target save
//   // structure me month field hona better hai.
//   // =========================================================
//   const getMonthName = (item) => {
//     return (
//       item?.month ||
//       item?.Month ||
//       ""
//     );
//   };

//   // =========================================================
//   // GET ALL PRODUCTS FROM ONE TARGET
//   // =========================================================
//   const getProducts = (target) => {
//     return Array.isArray(target?.products)
//       ? target.products
//       : [];
//   };

//   // =========================================================
//   // GET YEARLY PRODUCT TARGET
//   // =========================================================
//   const getYearlyProducts = () => {
//     const productMap = {};

//     targetData.forEach((target) => {
//       const products = getProducts(target);

//       products.forEach((product) => {
//         const productId =
//           product?.productId ||
//           product?.productName;

//         if (!productId) return;

//         if (!productMap[productId]) {
//           productMap[productId] = {
//             productId:
//               product?.productId,
//             productName:
//               product?.productName || "-",
//             targetQty: 0,
//             inputProductDetails:
//               product?.inputProductDetails || [],
//             outputProductDetails:
//               product?.outputProductDetails || [],
//           };
//         }

//         productMap[productId].targetQty +=
//           Number(product?.targetQty || 0);
//       });
//     });

//     return Object.values(productMap);
//   };

//   // =========================================================
//   // TARGET CARD
//   // =========================================================
//   const renderTargetCard = (
//     target,
//     index
//   ) => {
//     const products = getProducts(target);

//     return (
//       <div
//         key={target?._id || index}
//         style={{
//           border: "1px solid #ddd",
//           borderRadius: "10px",
//           padding: "15px",
//           background: "#fff",
//           boxShadow:
//             "0 2px 8px rgba(0,0,0,0.08)",
//         }}
//       >
//         {/* =================================================
//             CARD HEADER
//         ================================================= */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent:
//               "space-between",
//             alignItems: "center",
//             marginBottom: "15px",
//             paddingBottom: "10px",
//             borderBottom:
//               "1px solid #eee",
//           }}
//         >
//           <div>
//             <h4
//               style={{
//                 margin: 0,
//                 fontSize: "18px",
//                 fontWeight: "600",
//               }}
//             >
//               {getMonthName(target) ||
//                 `Target ${index + 1}`}
//             </h4>

//             <div
//               style={{
//                 fontSize: "12px",
//                 color: "#777",
//                 marginTop: "4px",
//               }}
//             >
//               FY:{" "}
//               {target?.financialYear ||
//                 fy}
//             </div>
//           </div>

//           <div
//             style={{
//               padding: "6px 12px",
//               borderRadius: "20px",
//               background: "#e8f1ff",
//               color: "#1e6bff",
//               fontSize: "12px",
//               fontWeight: "600",
//             }}
//           >
//             {target?.reportType ||
//               "monthly"}
//           </div>
//         </div>

//         {/* =================================================
//             PRODUCTS
//         ================================================= */}
//         {products.length === 0 ? (
//           <div
//             style={{
//               color: "#888",
//               fontSize: "13px",
//             }}
//           >
//             No products found
//           </div>
//         ) : (
//           products.map(
//             (product, productIndex) => (
//               <div
//                 key={
//                   product?.productId ||
//                   productIndex
//                 }
//                 style={{
//                   border:
//                     "1px solid #eee",
//                   borderRadius: "8px",
//                   padding: "12px",
//                   marginBottom: "10px",
//                   background: "#fafafa",
//                 }}
//               >
//                 {/* PRODUCT NAME */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent:
//                       "space-between",
//                     alignItems: "center",
//                     marginBottom: "12px",
//                   }}
//                 >
//                   <div>
//                     <div
//                       style={{
//                         fontSize: "15px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {product?.productName ||
//                         "-"}
//                     </div>

//                     <div
//                       style={{
//                         fontSize: "11px",
//                         color: "#888",
//                         marginTop: "3px",
//                       }}
//                     >
//                       Product ID:{" "}
//                       {product?.productId ||
//                         "-"}
//                     </div>
//                   </div>

//                   {/* TARGET QTY */}
//                   <div
//                     style={{
//                       textAlign: "right",
//                     }}
//                   >
//                     <div
//                       style={{
//                         fontSize: "11px",
//                         color: "#777",
//                       }}
//                     >
//                       Target Qty
//                     </div>

//                     <div
//                       style={{
//                         fontSize: "18px",
//                         fontWeight: "700",
//                       }}
//                     >
//                       {formatNumber(
//                         product?.targetQty
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* =================================================
//                     INPUT PRODUCT DETAILS
//                 ================================================= */}


//                 {/* =================================================
//                     OUTPUT PRODUCT DETAILS
//                 ================================================= */}
//                 {Array.isArray(
//                   product?.outputProductDetails
//                 ) &&
//                   product
//                     .outputProductDetails
//                     .length > 0 && (
//                     <div>
//                       <div
//                         style={{
//                           fontSize: "13px",
//                           fontWeight: "600",
//                           marginBottom: "6px",
//                         }}
//                       >
//                         Output Product Details
//                       </div>

//                       <div
//                         style={{
//                           display: "grid",
//                           gridTemplateColumns:
//                             "repeat(3, 1fr)",
//                           gap: "6px",
//                         }}
//                       >
//                         {product.outputProductDetails.map(
//                           (
//                             detail,
//                             detailIndex
//                           ) => (
//                             <div
//                               key={
//                                 detailIndex
//                               }
//                               style={{
//                                 padding: "7px",
//                                 border:
//                                   "1px solid #ddd",
//                                 borderRadius:
//                                   "6px",
//                                 background:
//                                   "#fff",
//                               }}
//                             >
//                               <div
//                                 style={{
//                                   fontSize:
//                                     "11px",
//                                   color:
//                                     "#777",
//                                 }}
//                               >
//                                 {detail?.unit ||
//                                   "-"}
//                               </div>

//                               <div
//                                 style={{
//                                   fontSize:
//                                     "11px",
//                                   color:
//                                     "#777",
//                                 }}
//                               >
//                                 Input:{" "}
//                                 {formatNumber(
//                                   detail?.inputQty
//                                 )}
//                               </div>

//                               <div
//                                 style={{
//                                   fontWeight:
//                                     "600",
//                                   fontSize:
//                                     "13px",
//                                 }}
//                               >
//                                 Calculated:{" "}
//                                 {formatNumber(
//                                   detail?.calculatedQty
//                                 )}
//                               </div>


//                             </div>
//                           )
//                         )}
//                       </div>
//                     </div>
//                   )}
//               </div>
//             )
//           )
//         )}
//       </div>
//     );
//   };

//   // =========================================================
//   // YEARLY VIEW
//   // =========================================================
//   const renderYearlyView = () => {
//     const yearlyProducts =
//       getYearlyProducts();

//     return (
//       <div>
//         {/* YEARLY HEADER */}
//         <div
//           style={{
//             border: "1px solid #ddd",
//             borderRadius: "10px",
//             padding: "15px",
//             marginBottom: "15px",
//             background: "#f8fbff",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent:
//                 "space-between",
//               alignItems: "center",
//             }}
//           >
//             <div>
//               <h3
//                 style={{
//                   margin: 0,
//                 }}
//               >
//                 Yearly Worker Target
//               </h3>

//               <div
//                 style={{
//                   fontSize: "13px",
//                   color: "#777",
//                   marginTop: "4px",
//                 }}
//               >
//                 Financial Year: {fy}
//               </div>
//             </div>

//             <div
//               style={{
//                 fontSize: "14px",
//                 fontWeight: "600",
//               }}
//             >
//               Total Months:{" "}
//               {targetData.length}
//             </div>
//           </div>
//         </div>

//         {/* YEARLY PRODUCTS */}
//         {yearlyProducts.length ===
//         0 ? (
//           <div
//             style={{
//               padding: "20px",
//               textAlign: "center",
//               color: "#888",
//               border:
//                 "1px solid #ddd",
//               borderRadius: "8px",
//             }}
//           >
//             No yearly target found
//           </div>
//         ) : (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns:
//                 "repeat(2, 1fr)",
//               gap: "15px",
//             }}
//           >
//             {yearlyProducts.map(
//               (product, index) => (
//                 <div
//                   key={
//                     product?.productId ||
//                     index
//                   }
//                   style={{
//                     border:
//                       "1px solid #ddd",
//                     borderRadius: "10px",
//                     padding: "15px",
//                     background:
//                       "#fff",
//                     boxShadow:
//                       "0 2px 8px rgba(0,0,0,0.08)",
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontSize: "16px",
//                       fontWeight: "600",
//                       marginBottom:
//                         "5px",
//                     }}
//                   >
//                     {product?.productName ||
//                       "-"}
//                   </div>

//                   <div
//                     style={{
//                       fontSize: "12px",
//                       color: "#888",
//                       marginBottom:
//                         "12px",
//                     }}
//                   >
//                     Product ID:{" "}
//                     {product?.productId ||
//                       "-"}
//                   </div>

//                   <div
//                     style={{
//                       padding: "12px",
//                       borderRadius: "8px",
//                       background:
//                         "#f1f7ff",
//                     }}
//                   >
//                     <div
//                       style={{
//                         fontSize:
//                           "12px",
//                         color: "#777",
//                       }}
//                     >
//                       Yearly Target Qty
//                     </div>

//                     <div
//                       style={{
//                         fontSize:
//                           "24px",
//                         fontWeight:
//                           "700",
//                         marginTop:
//                           "3px",
//                       }}
//                     >
//                       {formatNumber(
//                         product?.targetQty
//                       )}
//                     </div>
//                   </div>

//                   {/* OUTPUT */}
//                   {Array.isArray(
//                     product?.outputProductDetails
//                   ) &&
//                     product
//                       .outputProductDetails
//                       .length > 0 && (
//                       <div
//                         style={{
//                           marginTop:
//                             "12px",
//                         }}
//                       >
//                         <div
//                           style={{
//                             fontSize:
//                               "13px",
//                             fontWeight:
//                               "600",
//                             marginBottom:
//                               "6px",
//                           }}
//                         >
//                           Output Details
//                         </div>

//                         {product.outputProductDetails.map(
//                           (
//                             detail,
//                             detailIndex
//                           ) => (
//                             <div
//                               key={
//                                 detailIndex
//                               }
//                               style={{
//                                 display:
//                                   "flex",
//                                 justifyContent:
//                                   "space-between",
//                                 padding:
//                                   "6px 0",
//                                 borderBottom:
//                                   "1px solid #eee",
//                                 fontSize:
//                                   "12px",
//                               }}
//                             >
//                               <span>
//                                 {
//                                   detail?.unit
//                                 }
//                               </span>

//                               <strong>
//                                 {formatNumber(
//                                   detail?.calculatedQty
//                                 )}
//                               </strong>
//                             </div>
//                           )
//                         )}
//                       </div>
//                     )}
//                 </div>
//               )
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   // =========================================================
//   // RENDER
//   // =========================================================
//   return (
//     <div
//       style={{
//         padding: "20px",
//       }}
//     >
//       {/* =====================================================
//           TOP FILTER
//       ====================================================== */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent:
//             "space-between",
//           alignItems: "flex-end",
//           marginBottom: "20px",
//           flexWrap: "wrap",
//           gap: "15px",
//         }}
//       >
//         {/* FY */}
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             minWidth: "180px",
//           }}
//         >
//           <label
//             style={{
//               fontSize: "14px",
//               fontWeight: "600",
//               marginBottom: "6px",
//             }}
//           >
//             Financial Year
//           </label>

//           <select
//             value={fy}
//             onChange={(e) =>
//               setFy(e.target.value)
//             }
//             style={{
//               padding: "7px 10px",
//               borderRadius: "7px",
//               border:
//                 "1px solid #ccc",
//               fontSize: "14px",
//               background: "#fff",
//             }}
//           >
//             {generateFYOptions().map(
//               (year) => (
//                 <option
//                   key={year}
//                   value={year}
//                 >
//                   {year}
//                 </option>
//               )
//             )}
//           </select>
//         </div>

//         {/* MONTHLY / YEARLY */}
//         <div
//           style={{
//             display: "flex",
//             gap: "8px",
//           }}
//         >
//           <button
//             onClick={() =>
//               setViewType("monthly")
//             }
//             style={{
//               padding:
//                 "8px 18px",
//               borderRadius: "7px",
//               border: "none",
//               cursor: "pointer",
//               background:
//                 viewType ===
//                 "monthly"
//                   ? "#1e6bff"
//                   : "#ddd",
//               color:
//                 viewType ===
//                 "monthly"
//                   ? "#fff"
//                   : "#000",
//               fontWeight: "600",
//             }}
//           >
//             Monthly
//           </button>

//           <button
//             onClick={() =>
//               setViewType("yearly")
//             }
//             style={{
//               padding:
//                 "8px 18px",
//               borderRadius: "7px",
//               border: "none",
//               cursor: "pointer",
//               background:
//                 viewType ===
//                 "yearly"
//                   ? "#1e6bff"
//                   : "#ddd",
//               color:
//                 viewType ===
//                 "yearly"
//                   ? "#fff"
//                   : "#000",
//               fontWeight: "600",
//             }}
//           >
//             Yearly
//           </button>
//             <button
//     onClick={() =>
//       navigate("/sales-and-purchases?view=CreateTarget")
//     }
//     style={{
//       padding: "8px 18px",
//       borderRadius: "7px",
//       border: "none",
//       cursor: "pointer",
//       background: "#28a745",
//       color: "#fff",
//       fontWeight: "600",
//       boxShadow:
//         "0 2px 6px rgba(0,0,0,0.1)",
//     }}
//   >
//     + Create Target
//   </button>
//         </div>
//       </div>

//       {/* =====================================================
//           TITLE
//       ====================================================== */}
//       <div
//         style={{
//           marginBottom: "15px",
//         }}
//       >
//         <h3
//           style={{
//             margin: 0,
//           }}
//         >
//           Worker Target
//         </h3>

//         <div
//           style={{
//             fontSize: "13px",
//             color: "#777",
//             marginTop: "4px",
//           }}
//         >
//           Financial Year: {fy}
//         </div>
//       </div>

//       {/* =====================================================
//           LOADING
//       ====================================================== */}
//       {loading && (
//         <div
//           style={{
//             padding: "30px",
//             textAlign: "center",
//           }}
//         >
//           Loading worker targets...
//         </div>
//       )}

//       {/* =====================================================
//           MONTHLY
//       ====================================================== */}
//       {!loading &&
//         viewType ===
//           "monthly" && (
//           <>
//             {targetData.length ===
//             0 ? (
//               <div
//                 style={{
//                   padding: "30px",
//                   textAlign:
//                     "center",
//                   border:
//                     "1px solid #ddd",
//                   borderRadius:
//                     "8px",
//                   color: "#888",
//                 }}
//               >
//                 No worker target
//                 found for {fy}
//               </div>
//             ) : (
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns:
//                     "repeat(3, 1fr)",
//                   gap: "15px",
//                 }}
//               >
//                 {targetData.map(
//                   (
//                     target,
//                     index
//                   ) =>
//                     renderTargetCard(
//                       target,
//                       index
//                     )
//                 )}
//               </div>
//             )}
//           </>
//         )}

//       {/* =====================================================
//           YEARLY
//       ====================================================== */}
//       {!loading &&
//         viewType ===
//           "yearly" &&
//         renderYearlyView()}
//     </div>
//   );
// };

// export default Target;






import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../../AxiosConfig";
import { Edit, Trash2 } from "lucide-react";
// const Target = () => {
//   const navigate = useNavigate();
//   const [selectedMonthData, setSelectedMonthData] = useState(null);

//   const monthOrder = [
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//     "January",
//     "February",
//     "March",
//   ];

//   const getCurrentFY = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = today.getMonth() + 1;

//     if (month >= 4) {
//       return `${year}-${year + 1}`;
//     }

//     return `${year - 1}-${year}`;
//   };

//   const [fy, setFy] = useState(getCurrentFY());
//   const [targetData, setTargetData] = useState([]);
//   const [loading, setLoading] = useState(false);
// const [viewType, setViewType] = useState("monthly");
// const [achievementType, setAchievementType] = useState("target");
//   // ---------------------------------------------------
//   // FINANCIAL YEAR OPTIONS
//   // ---------------------------------------------------

//   const getFinancialYears = () => {
//     const currentYear = new Date().getFullYear();

//     return Array.from({ length: 6 }, (_, index) => {
//       const startYear = currentYear - index;

//       return `${startYear}-${startYear + 1}`;
//     });
//   };

//   // ---------------------------------------------------
//   // GET USER
//   // ---------------------------------------------------

//   const getUserData = () => {
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));

//       return user || {};
//     } catch (error) {
//       return {};
//     }
//   };

//   // ---------------------------------------------------
//   // LOAD TARGET DATA
//   // ---------------------------------------------------

//   const loadTargetData = async () => {
//     try {
//       setLoading(true);
//       const user = JSON.parse(
//         localStorage.getItem("userData")
//       );

//       const database = user?.database;

//       if (!database) {
//         setTargetData([]);
//         return;
//       }

//       const response = await axiosConfig.get(
//         `/production-steps/view-workerTarget/${database}/${fy}`
//       );

//       console.log("Target API Response:", response?.data);

//       let data = [];

//       if (Array.isArray(response?.data)) {
//         data = response.data;
//       } else if (Array.isArray(response?.data?.targets)) {
//         data = response.data.targets;
//       } else if (Array.isArray(response?.data?.data)) {
//         data = response.data.data;
//       }

//       // ---------------------------------------------------
//       // FY FILTER
//       // ---------------------------------------------------

//       const filteredData = data.filter((item) => {
//         if (!item?.financialYear) {
//           return true;
//         }

//         return (
//           String(item.financialYear).trim().toLowerCase() ===
//           String(fy).trim().toLowerCase()
//         );
//       });

//       console.log("Filtered Target Data:", filteredData);

//       setTargetData(filteredData);
//     } catch (error) {
//       console.error("Target Data Error:", error);

//       setTargetData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadTargetData();
//   }, [fy]);

//   // ---------------------------------------------------
//   // GET MONTH
//   // ---------------------------------------------------

//   // const getMonthName = (target) => {

//   //   const savedMonth =
//   //     target?.month ||
//   //     target?.Month ||
//   //     target?.targetMonth ||
//   //     target?.target_month ||
//   //     target?.monthName ||
//   //     target?.MonthName;

//   //   if (savedMonth) {
//   //     const monthValue = String(savedMonth)
//   //       .trim()
//   //       .toLowerCase();

//   //     const actualMonth = monthOrder.find(
//   //       (month) => month.toLowerCase() === monthValue
//   //     );

//   //     if (actualMonth) {
//   //       return actualMonth;
//   //     }

//   //     // Numeric month support
//   //     const numericMonth = Number(savedMonth);

//   //     if (
//   //       numericMonth >= 1 &&
//   //       numericMonth <= 12
//   //     ) {
//   //       const monthNames = [
//   //         "January",
//   //         "February",
//   //         "March",
//   //         "April",
//   //         "May",
//   //         "June",
//   //         "July",
//   //         "August",
//   //         "September",
//   //         "October",
//   //         "November",
//   //         "December",
//   //       ];

//   //       return monthNames[numericMonth - 1];
//   //     }
//   //   }

//   //   // ---------------------------------------------------
//   //   // OLD DATA FALLBACK
//   //   // ---------------------------------------------------

//   //   if (target?.createdAt) {
//   //     const date = new Date(target.createdAt);

//   //     if (!isNaN(date.getTime())) {
//   //       return date.toLocaleString("en-US", {
//   //         month: "long",
//   //       });
//   //     }
//   //   }

//   //   return "";
//   // };
//   const getTargetMonths = (target) => {
//     if (!Array.isArray(target?.month)) {
//       return [];
//     }

//     return target.month
//       .map((item) => Object.keys(item || {})[0])
//       .filter(Boolean);
//   };
//   // ---------------------------------------------------
//   // GET PRODUCTS
//   // ---------------------------------------------------

//   const getProducts = (target) => {
//     if (Array.isArray(target?.products)) {
//       return target.products;
//     }

//     return [];
//   };

//   // ---------------------------------------------------
//   // GET TARGET QTY
//   // ---------------------------------------------------

//   const handleDeleteProduct = async (
//     target,
//     product,
//     productIndex
//   ) => {
//     const confirmDelete = await swal({
//       title: "Are you sure?",
//       text: `Are you sure you want to delete "${product?.productName || "this product"
//         }"?`,
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     });

//     if (!confirmDelete) return;

//     try {
//       if (!target?._id) {
//         swal(
//           "Error",
//           "Target ID not found",
//           "error"
//         );
//         return;
//       }

//       await axiosConfig.delete(
//         `/production-steps/delete-workerTaget/${target._id}`
//       );

//       // API se fresh data lao
//       await loadTargetData();

//       // Selected month refresh
//       setSelectedMonthData(null);

//       swal(
//         "Success",
//         "Target deleted successfully",
//         "success"
//       );

//     } catch (error) {
//       console.error(
//         "Delete Worker Target Error:",
//         error
//       );

//       swal(
//         "Error",
//         error?.response?.data?.message ||
//         "Unable to delete target",
//         "error"
//       );
//     }
//   };

//   const getTargetQty = (target) => {
//     const products = getProducts(target);

//     return products.reduce((total, product) => {
//       return total + Number(product?.targetQty || 0);
//     }, 0);
//   };

//   // ---------------------------------------------------
//   // GET 12 MONTHS
//   // ---------------------------------------------------

//   // const getMonthlyTargets = () => {
//   //   return monthOrder.map((month) => {
//   //     const monthTargets = targetData.filter((target) => {
//   //       const targetMonth = getMonthName(target);

//   //       return (
//   //         String(targetMonth).trim().toLowerCase() ===
//   //         String(month).trim().toLowerCase()
//   //       );
//   //     });

//   //     let targetQty = 0;

//   //     monthTargets.forEach((target) => {
//   //       targetQty += getTargetQty(target);
//   //     });

//   //     return {
//   //       month,
//   //       targetQty,
//   //       targets: monthTargets,
//   //     };
//   //   });
//   // };
//   const getMonthlyTargets = () => {
//     return monthOrder.map((month) => {
//       let targetQty = 0;
//       const monthProducts = [];

//       targetData.forEach((target) => {
//         if (!Array.isArray(target?.month)) return;

//         // Is target ke month array me current month dhundo
//         const monthData = target.month.find((item) => {
//           const key = Object.keys(item || {})[0];

//           return (
//             String(key || "").trim().toLowerCase() ===
//             String(month).trim().toLowerCase()
//           );
//         });

//         if (!monthData) return;

//         const qty = Number(
//           monthData?.[Object.keys(monthData)[0]] || 0
//         );

//         targetQty += qty;

//         // Product details
//         const products = getProducts(target);

//         products.forEach((product) => {
//           monthProducts.push({
//             ...product,
//             monthQty: qty,
//             targetId: target?._id,
//             targetIndex: products.indexOf(product),
//             targetData: target,
//           });
//         });
//       });

//       return {
//         month,
//         targetQty,
//         products: monthProducts,
//       };
//     });
//   };
//   // ---------------------------------------------------
// // PERIOD CONFIG
// // ---------------------------------------------------

// const periodConfig = {
//   monthly: {
//     label: "Monthly",
//     months: 1,
//   },
//   quarterly: {
//     label: "Quarterly",
//     months: 3,
//   },
//   halfyearly: {
//     label: "Half Yearly",
//     months: 6,
//   },
//   yearly: {
//     label: "Yearly",
//     months: 12,
//   },
// };

// // ---------------------------------------------------
// // GET PERIOD TARGET
// // ---------------------------------------------------

// const getPeriodTarget = (months) => {
//   let total = 0;

//   targetData.forEach((target) => {
//     if (!Array.isArray(target?.month)) return;

//     target.month.forEach((monthData) => {
//       const key = Object.keys(monthData || {})[0];

//       if (!key) return;

//       const qty = Number(monthData?.[key] || 0);

//       total += qty;
//     });
//   });

//   // Average monthly target
//   return total / months;
// };
//   // ---------------------------------------------------
//   // GET YEARLY PRODUCTS
//   // ---------------------------------------------------

//   const getYearlyProducts = () => {
//     const productMap = {};

//     targetData.forEach((target) => {
//       const products = getProducts(target);

//       products.forEach((product) => {
//         const productId =
//           typeof product?.productId === "object"
//             ? product?.productId?._id
//             : product?.productId;

//         const key =
//           productId ||
//           product?.productName ||
//           "unknown";

//         if (!productMap[key]) {
//           productMap[key] = {
//             productId,
//             productName:
//               product?.productName || "-",
//             targetQty: 0,
//           };
//         }

//         productMap[key].targetQty += Number(
//           product?.targetQty || 0
//         );
//       });
//     });

//     return Object.values(productMap);
//   };

//   // ---------------------------------------------------
//   // MONTH CARD
//   // ---------------------------------------------------

//   // const renderMonthCard = (item, index) => {
//   //   return (
//   //     <Card
//   //       key={index}
//   //       style={{
//   //         height: "100%",
//   //         borderRadius: "10px",
//   //         border: "1px solid #ddd",
//   //         boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
//   //       }}
//   //     >
//   //       <CardBody>
//   //         {/* MONTH */}

//   //         <div
//   //           style={{
//   //             display: "flex",
//   //             justifyContent: "space-between",
//   //             alignItems: "center",
//   //             marginBottom: "15px",
//   //           }}
//   //         >
//   //           <h5
//   //             style={{
//   //               margin: 0,
//   //               fontWeight: "600",
//   //             }}
//   //           >
//   //             {item.month}
//   //           </h5>

//   //           <span
//   //             style={{
//   //               fontSize: "12px",
//   //               padding: "4px 8px",
//   //               borderRadius: "5px",
//   //               background:
//   //                 item.targetQty > 0
//   //                   ? "#e8f5e9"
//   //                   : "#f5f5f5",
//   //             }}
//   //           >
//   //             {fy}
//   //           </span>
//   //         </div>

//   //         {/* TARGET QTY */}

//   //         <div
//   //           style={{
//   //             fontSize: "13px",
//   //             color: "#777",
//   //             marginBottom: "5px",
//   //           }}
//   //         >
//   //           Target Qty
//   //         </div>

//   //         <div
//   //           style={{
//   //             fontSize: "28px",
//   //             fontWeight: "700",
//   //             marginBottom: "15px",
//   //           }}
//   //         >
//   //           {item.targetQty}
//   //         </div>

//   //         {/* PRODUCT DETAILS */}


//   //       </CardBody>
//   //     </Card>
//   //   );
//   // };
//   const renderMonthCard = (item, index) => {
//     const isSelected =
//       selectedMonthData?.month === item.month;

//     return (
//      <CardBody
//   key={index}
//   onClick={() => {
//     setSelectedMonthData(
//       isSelected ? null : item
//     );
//   }}
//   style={{
//     borderRadius: "10px",
//     border: isSelected
//       ? "2px solid #007bff"
//       : "1px solid #ddd",
//     boxShadow: isSelected
//       ? "0 4px 12px rgba(0,123,255,0.15)"
//       : "0 2px 6px rgba(0,0,0,0.08)",
//     cursor: "pointer",
//     transition: "0.2s",
//     height: "100%",
//     padding: "16px",
//   }}
// >
//         <CardBody>

//           {/* MONTH HEADER */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: "15px",
//             }}
//           >
//             <h5
//               style={{
//                 margin: 0,
//                 fontWeight: "600",
//               }}
//             >
//               {item.month}
//             </h5>

//             <span
//               style={{
//                 fontSize: "12px",
//                 padding: "4px 8px",
//                 borderRadius: "5px",
//                 background:
//                   item.targetQty > 0
//                     ? "#e8f5e9"
//                     : "#f5f5f5",
//               }}
//             >
//               {fy}
//             </span>
//           </div>

//           {/* TARGET QTY */}
//           <div
//             style={{
//               fontSize: "13px",
//               color: "#777",
//               marginBottom: "5px",
//             }}
//           >
//             Target Qty
//           </div>

//           <div
//             style={{
//               fontSize: "28px",
//               fontWeight: "700",
//               marginBottom: "10px",
//             }}
//           >
//             {Number(item.targetQty || 0).toFixed(2)}
//           </div>

//           {/* PRODUCT COUNT */}
//           <div
//             style={{
//               fontSize: "13px",
//               color: "#777",
//               marginBottom: "10px",
//             }}
//           >
//             Products: {item.products?.length || 0}
//           </div>

//           {/* =============================== */}
//           {/* SELECTED MONTH PRODUCT DETAILS */}
//           {/* =============================== */}

//           {isSelected && (
//             <div
//               style={{
//                 marginTop: "15px",
//                 paddingTop: "15px",
//                 borderTop: "1px solid #ddd",
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div
//                 style={{
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   marginBottom: "10px",
//                 }}
//               >
//                 Product Target
//               </div>

//               {item.products?.length === 0 ? (
//                 <div
//                   className="text-muted text-center"
//                   style={{
//                     padding: "15px 5px",
//                     fontSize: "13px",
//                   }}
//                 >
//                   No product target found
//                 </div>
//               ) : (
//                 <div
//                   style={{
//                     maxHeight: "250px",
//                     overflowY: "auto",
//                   }}
//                 >

// {item.products.map((product, productIndex) => (
//   <div
//     key={productIndex}
//     style={{
//       padding: "10px 0",
//       borderBottom: "1px solid #eee",
//       cursor: "pointer",
//     }}
//     onClick={(e) => {
//       e.stopPropagation();

//       navigate("/sales-and-purchases?view=CreateTarget", {
//         state: {
//           editMode: true,
//           targetId: product?.targetId,
//           target: product?.targetData,
//           product: product,
//           productIndex: product?.targetIndex,
//           financialYear: fy,
//           month: item.month,
//         },
//       });
//     }}
//     title="Click to edit"
//   >
//     <div
//       className="d-flex justify-content-between align-items-center"
//       style={{ gap: "10px" }}
//     >
//       <div style={{ flex: 1 }}>
//         <div
//           style={{
//             fontSize: "13px",
//             fontWeight: "600",
//           }}
//         >
//           {product?.productName || "-"}
//         </div>

//         <div
//           style={{
//             fontSize: "12px",
//             color: "#777",
//             marginTop: "3px",
//           }}
//         >
//           Target:{" "}
//           <strong>
//             {Number(product?.monthQty || 0).toFixed(2)}
//           </strong>
//         </div>
//       </div>

//       {/* Edit/Delete buttons removed */}
//     </div>
//   </div>
// ))}


//                 </div>
//               )}
//             </div>
//           )}

//           {/* CLICK TEXT */}
//           {!isSelected && (
//             <div
//               style={{
//                 marginTop: "12px",
//                 fontSize: "12px",
//                 color: "#007bff",
//                 fontWeight: "500",
//               }}
//             >
//               Click to view products →
//             </div>
//           )}

//           {isSelected && (
//             <div
//               style={{
//                 marginTop: "12px",
//                 fontSize: "12px",
//                 color: "#6c757d",
//               }}
//             >
//               Click month to close
//             </div>
//           )}

//         </CardBody>
//       </CardBody>
//     );
//   };
//   // ---------------------------------------------------
//   // MONTHLY VIEW
//   // ---------------------------------------------------

//   //   const renderMonthlyView = () => {
//   //   const monthlyTargets = getMonthlyTargets();

//   //   return (
//   //     <div
//   //       style={{
//   //         display: "grid",
//   //         gridTemplateColumns: "repeat(6, 1fr)",
//   //         gap: "15px",
//   //       }}
//   //     >
//   //       {monthlyTargets.map((item, index) =>
//   //         renderMonthCard(item, index)
//   //       )}
//   //     </div>
//   //   );
//   // };
//   const renderMonthlyView = () => {
//     const monthlyTargets = getMonthlyTargets();

//     return (
//       <div>
//         {/* MONTH CARDS */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(6, 1fr)",
//             gap: "15px",
//           }}
//         >
//           {monthlyTargets.map((item, index) =>
//             renderMonthCard(item, index)
//           )}
//         </div>

//         {/* SELECTED MONTH DETAILS */}

//       </div>
//     );
//   };
//   // ---------------------------------------------------
//   // YEARLY VIEW
//   // ---------------------------------------------------

//   const renderYearlyView = () => {
//     const yearlyProducts =
//       getYearlyProducts();

//     const totalYearlyTarget =
//       yearlyProducts.reduce(
//         (total, product) =>
//           total +
//           Number(product?.targetQty || 0),
//         0
//       );

//     return (
//       <div>
//         {/* TOTAL YEAR TARGET */}

//         <Card
//           style={{
//             marginBottom: "20px",
//             borderRadius: "10px",
//             border: "1px solid #ddd",
//           }}
//         >
//           <CardBody>
//             <div
//               style={{
//                 fontSize: "14px",
//                 color: "#777",
//               }}
//             >
//               Total Target - {fy}
//             </div>

//             <div
//               style={{
//                 fontSize: "30px",
//                 fontWeight: "700",
//                 marginTop: "5px",
//               }}
//             >
//               {totalYearlyTarget}
//             </div>
//           </CardBody>
//         </Card>

//         {/* PRODUCTS */}

//         {yearlyProducts.length === 0 ? (
//           <div
//             style={{
//               padding: "30px",
//               textAlign: "center",
//               border: "1px solid #ddd",
//               borderRadius: "8px",
//               color: "#888",
//               background: "#fff",
//             }}
//           >
//             No target found for {fy}
//           </div>
//         ) : (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns:
//                 "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "15px",
//             }}
//           >
//             {yearlyProducts.map(
//               (product, index) => (
//                 <Card
//                   key={index}
//                   style={{
//                     borderRadius: "10px",
//                     border:
//                       "1px solid #ddd",
//                   }}
//                 >
//                   <CardBody>
//                     <div
//                       style={{
//                         fontWeight: "600",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {product?.productName ||
//                         "-"}
//                     </div>

//                     <div
//                       style={{
//                         fontSize: "13px",
//                         color: "#777",
//                       }}
//                     >
//                       Yearly Target Qty
//                     </div>

//                     <div
//                       style={{
//                         fontSize: "25px",
//                         fontWeight: "700",
//                         marginTop: "5px",
//                       }}
//                     >
//                       {product?.targetQty || 0}
//                     </div>
//                   </CardBody>
//                 </Card>
//               )
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   // ---------------------------------------------------
//   // MAIN UI
//   // ---------------------------------------------------

//   return (
//     <><div className="container-fluid">
//       {/* HEADER */}

//       <Row className="align-items-center mb-3">
//         <Col md="4">
//           <h4
//             style={{
//               margin: 0,
//               fontWeight: "600",
//             }}
//           >
//             Worker Target
//           </h4>
//         </Col>

//         {/* FY */}

//         <Col
//           md="4"
//           className="mt-2 mt-md-0"
//         >
//           <div
//             className="d-flex align-items-center"
//             style={{ gap: "10px" }}
//           >
//             <label
//               style={{
//                 margin: 0,
//                 fontWeight: "500",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               Financial Year
//             </label>

//             <Input
//               type="select"
//               value={fy}
//               onChange={(e) => setFy(e.target.value)}
//             >
//               {getFinancialYears().map(
//                 (year) => (
//                   <option
//                     key={year}
//                     value={year}
//                   >
//                     {year}
//                   </option>
//                 )
//               )}
//             </Input>
//           </div>
//         </Col>

//         {/* CREATE TARGET */}

//         <Col
//           md="4"
//           className="text-md-end mt-2 mt-md-0"
//         >
//           <Button
//             color="primary"
//             onClick={() => navigate("/sales-and-purchases?view=CreateTarget")}
//           >
//             + Create Target
//           </Button>
//         </Col>
//       </Row>

//       {/* VIEW BUTTONS */}

//       <Row className="mb-3">
//         <Col>
//           <div
//             className="d-flex"
//             style={{ gap: "8px" }}
//           >
//             <Button
//               color={viewType === "monthly"
//                 ? "primary"
//                 : "secondary"}
//               outline={viewType !== "monthly"}
//               onClick={() => setViewType("monthly")}
//             >
//               Monthly
//             </Button>

//             <Button
//               color={viewType === "yearly"
//                 ? "primary"
//                 : "secondary"}
//               outline={viewType !== "yearly"}
//               onClick={() => setViewType("yearly")}
//             >
//               Yearly
//             </Button>
//           </div>
//         </Col>
//       </Row>

//       {/* LOADING */}

//       {loading ? (
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{
//             minHeight: "300px",
//           }}
//         >
//           <Spinner color="primary" />
//         </div>
//       ) : (
//         <>
//           {/* MONTHLY */}

//           {viewType === "monthly" &&
//             renderMonthlyView()}

//           {/* YEARLY */}

//           {viewType === "yearly" &&
//             renderYearlyView()}
//         </>
//       )}
//     </div>
//     </>
//   );
// };
const Target = () => {
  const navigate = useNavigate();

  const [selectedMonthData, setSelectedMonthData] =
    useState(null);

  const [targetData, setTargetData] = useState([]);
  const [achievementData, setAchievementData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ---------------------------------------------------
  // VIEW TYPE
  // monthly / quarterly / halfyearly / yearly
  // ---------------------------------------------------

  const [viewType, setViewType] =
    useState("monthly");

  // ---------------------------------------------------
  // DATA TYPE
  // target / achievement / balance
  // ---------------------------------------------------

  const [dataType, setDataType] =
    useState("target");

  // ---------------------------------------------------
  // MONTH ORDER
  // ---------------------------------------------------

  const monthOrder = [
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
  ];

  // ---------------------------------------------------
  // CURRENT FINANCIAL YEAR
  // ---------------------------------------------------

  const getCurrentFY = () => {
    const today = new Date();

    const year = today.getFullYear();

    const month = today.getMonth() + 1;

    if (month >= 4) {
      return `${year}-${year + 1}`;
    }

    return `${year - 1}-${year}`;
  };

  const [fy, setFy] =
    useState(getCurrentFY());

  // ---------------------------------------------------
  // FINANCIAL YEAR OPTIONS
  // ---------------------------------------------------

  const getFinancialYears = () => {
    const currentYear =
      new Date().getFullYear();

    return Array.from(
      { length: 6 },
      (_, index) => {
        const startYear =
          currentYear - index;

        return `${startYear}-${startYear + 1}`;
      }
    );
  };

  // ---------------------------------------------------
  // GET USER
  // ---------------------------------------------------

  const getUserData = () => {
    try {
      const user = JSON.parse(
        localStorage.getItem("userData")
      );

      return user || {};
    } catch (error) {
      return {};
    }
  };

  // ---------------------------------------------------
  // LOAD TARGET DATA
  // ---------------------------------------------------

  const loadTargetData = async () => {
    try {
      setLoading(true);

      const user = getUserData();

      const database = user?.database;

      if (!database) {
        setTargetData([]);
        return;
      }

      const response =
        await axiosConfig.get(
          `/production-steps/view-workerTarget/${database}/${fy}`
        );
      console.log(
        "Target API Response:",
        response?.data
      );
      const achievements = Array.isArray(response?.data?.achievements)
        ? response.data.achievements
        : [];

      setAchievementData(achievements);
      let data = [];

      if (
        Array.isArray(
          response?.data
        )
      ) {
        data = response.data;
      } else if (
        Array.isArray(
          response?.data?.targets
        )
      ) {
        data =
          response.data.targets;
      } else if (
        Array.isArray(
          response?.data?.data
        )
      ) {
        data =
          response.data.data;
      }

      // ---------------------------------------------------
      // FY FILTER
      // ---------------------------------------------------

      const filteredData =
        data.filter((item) => {
          if (!item?.financialYear) {
            return true;
          }

          return (
            String(
              item.financialYear
            )
              .trim()
              .toLowerCase() ===
            String(fy)
              .trim()
              .toLowerCase()
          );
        });

      console.log(
        "Filtered Target Data:",
        filteredData
      );

      setTargetData(
        filteredData
      );

      setSelectedMonthData(
        null
      );
    } catch (error) {
      console.error(
        "Target Data Error:",
        error
      );

      setTargetData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTargetData();
  }, [fy]);

  // ---------------------------------------------------
  // GET TARGET MONTHS
  // ---------------------------------------------------

  const getTargetMonths = (
    target
  ) => {
    if (
      !Array.isArray(
        target?.month
      )
    ) {
      return [];
    }

    return target.month
      .map((item) => {
        return Object.keys(
          item || {}
        )[0];
      })
      .filter(Boolean);
  };

  // ---------------------------------------------------
  // GET PRODUCTS
  // ---------------------------------------------------

  const getProducts = (
    target
  ) => {
    if (
      Array.isArray(
        target?.products
      )
    ) {
      return target.products;
    }

    return [];
  };

  // ---------------------------------------------------
  // DELETE TARGET
  // ---------------------------------------------------

  const handleDeleteProduct =
    async (
      target,
      product,
      productIndex
    ) => {
      const confirmDelete =
        await swal({
          title: "Are you sure?",
          text: `Are you sure you want to delete "${product?.productName ||
            "this product"
            }"?`,
          icon: "warning",
          buttons: [
            "Cancel",
            "Delete",
          ],
          dangerMode: true,
        });

      if (!confirmDelete) {
        return;
      }

      try {
        if (!target?._id) {
          swal(
            "Error",
            "Target ID not found",
            "error"
          );

          return;
        }

        await axiosConfig.delete(
          `/production-steps/delete-workerTaget/${target._id}`
        );

        await loadTargetData();

        setSelectedMonthData(
          null
        );

        swal(
          "Success",
          "Target deleted successfully",
          "success"
        );
      } catch (error) {
        console.error(
          "Delete Worker Target Error:",
          error
        );

        swal(
          "Error",
          error?.response?.data
            ?.message ||
          "Unable to delete target",
          "error"
        );
      }
    };

  // ---------------------------------------------------
  // GET MONTH DATA
  // ---------------------------------------------------

  const getMonthDataByName = (
    monthlyData,
    month
  ) => {
    return (
      monthlyData.find(
        (item) =>
          item.month === month
      ) || {
        month,
        targetQty: 0,
        products: [],
      }
    );
  };

  // ---------------------------------------------------
  // GET MONTHLY TARGETS
  // ---------------------------------------------------

  const getMonthlyTargets = () => {
    return monthOrder.map(
      (month) => {
        let targetQty = 0;

        const monthProducts = [];

        targetData.forEach(
          (target) => {
            if (
              !Array.isArray(
                target?.month
              )
            ) {
              return;
            }

            const monthData =
              target.month.find(
                (item) => {
                  const key =
                    Object.keys(
                      item || {}
                    )[0];

                  return (
                    String(
                      key || ""
                    )
                      .trim()
                      .toLowerCase() ===
                    String(
                      month
                    )
                      .trim()
                      .toLowerCase()
                  );
                }
              );

            if (!monthData) {
              return;
            }

            const monthKey =
              Object.keys(
                monthData
              )[0];

            const qty =
              Number(
                monthData?.[
                monthKey
                ] || 0
              );

            targetQty += qty;

            // -----------------------------------------
            // PRODUCT DETAILS
            // -----------------------------------------

            const products =
              getProducts(
                target
              );

            products.forEach(
              (
                product,
                productIndex
              ) => {
                monthProducts.push(
                  {
                    ...product,

                    monthQty: qty,

                    targetId:
                      target?._id,

                    targetIndex:
                      productIndex,

                    targetData:
                      target,

                    month: month,
                  }
                );
              }
            );
          }
        );

        return {
          month,

          targetQty,

          products:
            monthProducts,
        };
      }
    );
  };

  // ---------------------------------------------------
  // QUARTER CONFIG
  // ---------------------------------------------------

  const quarterConfig = [
    {
      name: "Q1",

      months: [
        "April",
        "May",
        "June",
      ],
    },

    {
      name: "Q2",

      months: [
        "July",
        "August",
        "September",
      ],
    },

    {
      name: "Q3",

      months: [
        "October",
        "November",
        "December",
      ],
    },

    {
      name: "Q4",

      months: [
        "January",
        "February",
        "March",
      ],
    },
  ];

  // ---------------------------------------------------
  // HALF YEAR CONFIG
  // ---------------------------------------------------

  const halfYearConfig = [
    {
      name: "H1",

      months: [
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
      ],
    },

    {
      name: "H2",

      months: [
        "October",
        "November",
        "December",
        "January",
        "February",
        "March",
      ],
    },
  ];

  // ---------------------------------------------------
  // GET QUARTER FOR MONTH
  // ---------------------------------------------------

  const getQuarterForMonth = (
    month
  ) => {
    return quarterConfig.find(
      (quarter) =>
        quarter.months.includes(
          month
        )
    );
  };

  // ---------------------------------------------------
  // GET HALF FOR MONTH
  // ---------------------------------------------------

  const getHalfForMonth = (
    month
  ) => {
    return halfYearConfig.find(
      (half) =>
        half.months.includes(
          month
        )
    );
  };

  // ---------------------------------------------------
  // GET MONTH CARD DATA
  // IMPORTANT:
  // EVERY FILTER RETURNS 12 MONTHS
  // ---------------------------------------------------

  const getFilteredMonthCards = () => {
    const monthlyData = getMonthlyTargets();

    return monthOrder.map((month) => {
      const monthData = getMonthDataByName(
        monthlyData,
        month
      );

      const targetQty = Number(
        monthData?.targetQty || 0
      );

      // -----------------------------------------
      // TOTAL ACHIEVEMENT FOR THIS MONTH
      // Multiple achievement entries possible
      // -----------------------------------------
      const totalAchievement = achievementData
        .filter((item) => {
          return (
            String(item?.month || "")
              .trim()
              .toLowerCase() ===
            String(month)
              .trim()
              .toLowerCase()
          );
        })
        .reduce((total, item) => {
          return (
            total +
            Number(item?.achievementQty || 0)
          );
        }, 0);

      // -----------------------------------------
      // BALANCE = TARGET - TOTAL ACHIEVEMENT
      // -----------------------------------------
      const balanceQty =
        targetQty - totalAchievement;

      let displayQty = targetQty;

      if (dataType === "target") {
        if (viewType === "monthly") {
          displayQty = targetQty;
        }

        if (viewType === "quarterly") {
          displayQty = targetQty / 3;
        }

        if (viewType === "halfyearly") {
          displayQty = targetQty / 6;
        }

        if (viewType === "yearly") {
          displayQty = targetQty / 12;
        }
      }

      // -----------------------------------------
      // ACHIEVEMENT
      // -----------------------------------------
      if (dataType === "achievement") {
        displayQty = totalAchievement;
      }

      // -----------------------------------------
      // BALANCE
      // Target - Total Achievement
      // -----------------------------------------
      if (dataType === "balance") {
        displayQty = balanceQty;
      }

      return {
        ...monthData,

        month,

        targetQty,

        achievementQty: totalAchievement,

        balanceQty,

        displayQty,

        products:
          monthData?.products || [],
      };
    });
  };

  // ---------------------------------------------------
  // GET DISPLAY QUANTITY
  // ---------------------------------------------------

  const getDisplayQty = (item) => {
    if (dataType === "target") {
      return Number(item?.displayQty || 0);
    }

    if (dataType === "achievement") {
      return Number(
        item?.achievementQty || 0
      );
    }

    if (dataType === "balance") {
      return (
        Number(item?.targetQty || 0) -
        Number(item?.achievementQty || 0)
      );
    }

    return 0;
  };

  // ---------------------------------------------------
  // DISPLAY LABEL
  // ---------------------------------------------------

  const getDisplayLabel = () => {
    if (
      dataType ===
      "achievement"
    ) {
      return "Achievement";
    }

    if (
      dataType ===
      "balance"
    ) {
      return "Balance";
    }

    if (
      viewType ===
      "monthly"
    ) {
      return "Monthly Target";
    }

    if (
      viewType ===
      "quarterly"
    ) {
      return "Quarterly Target / 3";
    }

    if (
      viewType ===
      "halfyearly"
    ) {
      return "Half Yearly Target / 6";
    }

    return "Yearly Target / 12";
  };

  // ---------------------------------------------------
  // RENDER MONTH CARD
  // ---------------------------------------------------
const getTotalBalance = () => {
  // Target quantity sirf ek baar
  const totalTarget = Number(
    targetData?.[0]?.products?.[0]?.targetQty || 0
  );

  // Achievement ki saari entries add hongi
  const totalAchievement = achievementData.reduce(
    (total, item) => {
      return (
        total +
        Number(item?.achievementQty || 0)
      );
    },
    0
  );
  // Achievement - Target
  return totalTarget - totalAchievement;
};
  const renderMonthCard = (
    item,
    index
  ) => {
    const isSelected =
      selectedMonthData?.month ===
      item.month;

    const displayQty =
      getDisplayQty(item);

    return (
      <Card
        key={index}
        style={{
          borderRadius:
            "10px",

          border: isSelected
            ? "2px solid #007bff"
            : "1px solid #ddd",

          boxShadow:
            isSelected
              ? "0 4px 12px rgba(0,123,255,0.15)"
              : "0 2px 6px rgba(0,0,0,0.08)",

          cursor: "pointer",

          transition:
            "0.2s",

          height: "100%",

          background:
            "#fff",
        }}
        onClick={() => {
          setSelectedMonthData(
            isSelected
              ? null
              : item
          );
        }}
      >
        <CardBody>
          {/* ========================================= */}
          {/* HEADER */}
          {/* ========================================= */}

          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              marginBottom:
                "12px",
            }}
          >
            <h5
              style={{
                margin: 0,
                fontWeight:
                  "600",
              }}
            >
              {item.month}
            </h5>

            <span
              style={{
                fontSize:
                  "11px",

                padding:
                  "4px 8px",

                borderRadius:
                  "5px",

                background:
                  "#f5f5f5",
              }}
            >
              {fy}
            </span>
          </div>

          {/* ========================================= */}
          {/* PERIOD INFO */}
          {/* ========================================= */}

          {viewType !==
            "monthly" && (
              <div
                style={{
                  fontSize:
                    "11px",

                  color:
                    "#999",

                  marginBottom:
                    "8px",
                }}
              >
                <strong>
                  {
                    item.periodName
                  }
                </strong>

                {" • "}

                {viewType ===
                  "quarterly"
                  ? "3 Months"
                  : viewType ===
                    "halfyearly"
                    ? "6 Months"
                    : "12 Months"}
              </div>
            )}

          {/* ========================================= */}
          {/* LABEL */}
          {/* ========================================= */}

          <div
            style={{
              fontSize:
                "13px",

              color:
                "#777",

              marginBottom:
                "4px",
            }}
          >
            {getDisplayLabel()}
          </div>

          {/* ========================================= */}
          {/* VALUE */}
          {/* ========================================= */}

          <div
            style={{
              fontSize:
                "28px",

              fontWeight:
                "700",

              marginBottom:
                "5px",
            }}
          >
            {displayQty.toFixed(
              2
            )}
          </div>

          {/* ========================================= */}
          {/* DIVISION INFO */}
          {/* ========================================= */}

          {/* {dataType ===
            "target" &&
            viewType !==
              "monthly" && (
              <div
                style={{
                  fontSize:
                    "11px",

                  color:
                    "#999",

                  marginBottom:
                    "10px",
                }}
              >
                Total{" "}
                {Number(
                  item?.originalQty ||
                    0
                ).toFixed(
                  2
                )}{" "}
                ÷{" "}
                {
                  item.divisor
                }
              </div>
            )} */}

          {/* ========================================= */}
          {/* PRODUCT COUNT */}
          {/* ========================================= */}

          <div
            style={{
              fontSize:
                "12px",

              color:
                "#777",

              marginBottom:
                "10px",
            }}
          >
            Products:{" "}
            {
              item
                ?.products
                ?.length || 0
            }
          </div>

          {/* ========================================= */}
          {/* PRODUCTS */}
          {/* ========================================= */}

          {isSelected && (
            <div
              style={{
                marginTop:
                  "15px",

                paddingTop:
                  "15px",

                borderTop:
                  "1px solid #ddd",
              }}
              onClick={(e) =>
                e.stopPropagation()
              }
            >
              <div
                style={{
                  fontSize:
                    "14px",

                  fontWeight:
                    "600",

                  marginBottom:
                    "10px",
                }}
              >
                Product Target
              </div>

              {item
                ?.products
                ?.length ===
                0 ? (
                <div
                  className="text-muted text-center"
                  style={{
                    padding:
                      "15px 5px",

                    fontSize:
                      "13px",
                  }}
                >
                  No product target
                  found
                </div>
              ) : (
                <div
                  style={{
                    maxHeight:
                      "250px",

                    overflowY:
                      "auto",
                  }}
                >
                  {item.products.map(
                    (
                      product,
                      productIndex
                    ) => {
                      // ----------------------------------
                      // PRODUCT MONTH TARGET
                      // ----------------------------------

                      let productQty =
                        Number(
                          product?.monthQty ||
                          0
                        );

                      // ----------------------------------
                      // PERIOD DIVISION
                      // ----------------------------------

                      if (
                        dataType ===
                        "target"
                      ) {
                        if (
                          viewType ===
                          "quarterly"
                        ) {
                          productQty =
                            productQty /
                            3;
                        }

                        if (
                          viewType ===
                          "halfyearly"
                        ) {
                          productQty =
                            productQty /
                            6;
                        }

                        if (
                          viewType ===
                          "yearly"
                        ) {
                          productQty =
                            productQty /
                            12;
                        }
                      }

                      // ----------------------------------
                      // ACHIEVEMENT
                      // ----------------------------------

                      if (
                        dataType ===
                        "achievement"
                      ) {
                        productQty =
                          Number(
                            product?.achievement ||
                            0
                          );
                      }

                      // ----------------------------------
                      // BALANCE
                      // ----------------------------------

                      if (
                        dataType ===
                        "balance"
                      ) {
                        let productTarget =
                          Number(
                            product?.monthQty ||
                            0
                          );

                        if (
                          viewType ===
                          "quarterly"
                        ) {
                          productTarget =
                            productTarget /
                            3;
                        }

                        if (
                          viewType ===
                          "halfyearly"
                        ) {
                          productTarget =
                            productTarget /
                            6;
                        }

                        if (
                          viewType ===
                          "yearly"
                        ) {
                          productTarget =
                            productTarget /
                            12;
                        }

                        productQty =
                          productTarget -
                          Number(
                            product?.achievement ||
                            0
                          );
                      }

                      return (
                        <div
                          key={
                            productIndex
                          }
                          style={{
                            padding:
                              "10px 0",

                            borderBottom:
                              "1px solid #eee",

                            cursor:
                              "pointer",
                          }}
                          onClick={(
                            e
                          ) => {
                            e.stopPropagation();

                            navigate(
                              "/sales-and-purchases?view=CreateTarget",
                              {
                                state:
                                {
                                  editMode:
                                    true,

                                  targetId:
                                    product?.targetId,

                                  target:
                                    product?.targetData,

                                  product:
                                    product,

                                  productIndex:
                                    product?.targetIndex,

                                  financialYear:
                                    fy,

                                  month:
                                    item.month,
                                },
                              }
                            );
                          }}
                          title="Click to edit"
                        >
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{
                              gap:
                                "10px",
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                              }}
                            >
                              <div
                                style={{
                                  fontSize:
                                    "13px",

                                  fontWeight:
                                    "600",
                                }}
                              >
                                {
                                  product?.productName ||
                                  "-"
                                }
                              </div>

                              <div
                                style={{
                                  fontSize:
                                    "12px",

                                  color:
                                    "#777",

                                  marginTop:
                                    "3px",
                                }}
                              >
                                {
                                  dataType ===
                                    "achievement"
                                    ? "Achievement"
                                    : dataType ===
                                      "balance"
                                      ? "Balance"
                                      : "Target"
                                }

                                :{" "}
                                <strong>
                                  {productQty.toFixed(
                                    2
                                  )}
                                </strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              )}
            </div>
          )}

          {/* ========================================= */}
          {/* FOOTER */}
          {/* ========================================= */}

          {!isSelected && (
            <div
              style={{
                marginTop:
                  "12px",

                fontSize:
                  "12px",

                color:
                  "#007bff",

                fontWeight:
                  "500",
              }}
            >
              Click to view
              products →
            </div>
          )}

          {isSelected && (
            <div
              style={{
                marginTop:
                  "12px",

                fontSize:
                  "12px",

                color:
                  "#6c757d",
              }}
            >
              Click month to
              close
            </div>
          )}
        </CardBody>
      </Card>
    );
  };

  // ---------------------------------------------------
  // RENDER ALL 12 MONTH CARDS
  // ---------------------------------------------------

  const renderAllMonthCards =
    () => {
      const data =
        getFilteredMonthCards();

      return (
        <div
          style={{
            display: "grid",

            gridTemplateColumns:
              "repeat(6, minmax(0, 1fr))",

            gap: "15px",
          }}
        >
          {data.map(
            (item, index) =>
              renderMonthCard(
                item,
                index
              )
          )}
        </div>
      );
    };

  // ---------------------------------------------------
  // MAIN UI
  // ---------------------------------------------------

  return (
    <>
      <div className="container-fluid">

        {/* ============================================= */}
        {/* HEADER */}
        {/* ============================================= */}

        <Row className="align-items-center mb-3">

          {/* TITLE - LEFT */}
          <Col md="4" sm="12">
            <h4
              style={{
                margin: 0,
                fontWeight: "600",
              }}
            >
              Worker Target
            </h4>
          </Col>

          {/* ALL BUTTONS - RIGHT */}
          <Col
            md="8"
            sm="12"
            className="d-flex justify-content-md-end justify-content-start mt-2 mt-md-0"
          >
            <div
              className="d-flex align-items-center flex-wrap"
              style={{
                gap: "8px",
              }}
            >
              {/* TARGET */}
              <Button
                color={dataType === "target" ? "primary" : "secondary"}
                outline={dataType !== "target"}
                onClick={() => setDataType("target")}
              >
                Target
              </Button>

              {/* ACHIEVEMENT */}
              <Button
                color={
                  dataType === "achievement"
                    ? "success"
                    : "secondary"
                }
                outline={dataType !== "achievement"}
                onClick={() =>
                  navigate(
                    "/sales-and-purchases?view=CreateAchievement"
                  )
                }
              >
                Achievement
              </Button>
              {/* CREATE TARGET */}
              <Button
                color="primary"
                onClick={() =>
                  navigate(
                    "/sales-and-purchases?view=CreateTarget"
                  )
                }
              >
                + Create Target
              </Button>
              {/* <div
                style={{
                  padding: "8px 14px",
                  border: "1px solid #ffc107",
                  borderRadius: "6px",
                  background: "#fff",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                Balance:{" "}
                {getTotalBalance().toFixed(2)}
              </div> */}
            </div>
          </Col>

        </Row>



        <Row className="mb-3 align-items-end">

          {/* TARGET VIEW */}
          <Col xs="auto">
            <div style={{ minWidth: "190px" }}>
              <label
                className="form-label fw-semibold mb-1"
                style={{
                  fontSize: "13px",
                  color: "#495057",
                }}
              >
                Target View
              </label>

              <Input
                type="select"
                value={viewType}
                onChange={(e) => setViewType(e.target.value)}
                style={{
                  width: "190px",
                  height: "38px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  boxShadow: "none",
                }}
              >
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="halfyearly">Half Yearly</option>
                <option value="yearly">Yearly</option>
              </Input>
            </div>
          </Col>

          {/* FINANCIAL YEAR */}
          <Col xs="auto">
            <div style={{ minWidth: "190px" }}>
              <label
                className="form-label fw-semibold mb-1"
                style={{
                  fontSize: "13px",
                  color: "#495057",
                }}
              >
                Financial Year
              </label>

              <Input
                type="select"
                value={fy}
                onChange={(e) => setFy(e.target.value)}
                style={{
                  width: "190px",
                  height: "38px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  boxShadow: "none",
                }}
              >
                {getFinancialYears().map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Input>
            </div>
          </Col>


        </Row>



        {/* ============================================= */}
        {/* LOADING */}
        {/* ============================================= */}

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minHeight:
                "300px",
            }}
          >
            <Spinner color="primary" />
          </div>
        ) : (
          <>
            {/* ========================================= */}
            {/* ALL VIEWS = SAME 12 MONTH CARDS */}
            {/* ========================================= */}

            {renderAllMonthCards()}
          </>
        )}
      </div>
    </>
  );
};
export default Target;